import React, { Suspense } from "react";
import { render } from "react-dom";
import { Router } from "react-router-dom";

import App from "./App";
import history from "./utils/history";
import { REACT_URL } from "./constant";
// import "antd/dist/antd.css";
import "./assets/vendors/style";
import { Spin } from "antd";
import { Provider } from "react-redux";
import configureStore from './store/configureSetup';

const store = configureStore({}, history);

const mountNode = document.getElementById("root");

window.addEventListener("error", (e) => {
  if (e.message) {
    const resizeObserverErrDiv = document.getElementById(
      "webpack-dev-server-client-overlay-div"
    );
    const resizeObserverErr = document.getElementById(
      "webpack-dev-server-client-overlay"
    );
    if (resizeObserverErr) {
      resizeObserverErr.setAttribute("style", "display: none");
    }
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.setAttribute("style", "display: none");
    }
  }
});

render(
  <Suspense
    fallback={
      <div
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {" "}
        <Spin size="large" spinning={true}></Spin>{" "}
      </div>
    }
  >
    <Provider store={store}>
      <Router basename={REACT_URL} history={history}>
        <App />
      </Router>
    </Provider>
  </Suspense>,
  mountNode
);
